import React from "react"
import SbEditable from "storyblok-react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import { StyledForm } from "./partials"
import { BrochureForm, ReferralForm, ContactForm } from "./formTypes"
import { GenericForm } from "./formTypes/GenericForm"

export const StoryblokForm = ({ key, isDark, blok, name, formId }) => {
  const formDataSources = useStaticQuery(graphql`
    query {
      allStoryblokDatasourceEntry(
        filter: { data_source: { regex: "/^form*/" } }
      ) {
        edges {
          node {
            id
            name
            value
            data_source
          }
        }
      }
    }
  `)

  const formRedirects =
    formDataSources?.allStoryblokDatasourceEntry?.edges.filter(
      (o) => o.node.data_source === blok?.fieldLevelDataSource
    )

  const form = () => {
    const { formType } = blok
    switch (formType.toLowerCase()) {
      case "brochure":
        return (
          <BrochureForm
            formId={formId}
            name={name}
            blok={blok}
            isDark={isDark}
            redirects={formRedirects}
          />
        )

      case "refe":
        return (
          <ReferralForm blok={blok} isDark={isDark} redirects={formRedirects} />
        )
      case "cont":
      case "lonl":
      case "sa3":
        return (
          <GenericForm
            formId={formId}
            name={name}
            blok={blok}
            isDark={isDark}
            redirects={formRedirects}
            formType={blok.formType}
          />
        )
      default:
        return <>MISSING FORM {blok.formType}</>
    }
  }

  return (
    <SbEditable content={blok}>
      <StyledForm data-name="form">{form()}</StyledForm>
    </SbEditable>
  )
}

StoryblokForm.propTypes = {
  blok: PropTypes.shape({}),
}
